import { atom } from "jotai";
import { creditAtomState, CreditTabType, creditSelectedTabAtom } from "./credit.atoms";
import { GraphQlAdapter } from "@/infrastructure/adapters/graphQl";
import { createLogger } from "@/infrastructure/services/logger";
import { CreditRepository } from "@/infrastructure/repositories/credit";
import { GetCreditUseCase } from "@/core/usecases/credit";
import { Credit } from "@/core/entities/credit";

const logger = createLogger("credit.actions");
const creditRepository = new CreditRepository(GraphQlAdapter.getInstance().getClient());
const getCreditUseCase = new GetCreditUseCase(creditRepository);

export const getCreditAtom = atom(null, async (get, set, remittanceItemId: number) => {
  set(creditAtomState, {
    ...get(creditAtomState),
    isLoading: true,
  });

  try {
    const credit = await getCreditUseCase.execute({ remittanceItemId: remittanceItemId });
    set(creditAtomState, {
      ...get(creditAtomState),
      credit,
      isLoading: false,
      error: null,
    });
  } catch (error: unknown) {
    set(creditAtomState, {
      ...get(creditAtomState),
      error: error as Error,
      isLoading: false,
    });
    logger.error(error instanceof Error ? error.message : "Error getting credit", error);
    throw error;
  }
});

export const setCreditSelectedTabAtom = atom(null, (_, set, selectedTab: CreditTabType | null) => {
  set(creditSelectedTabAtom, selectedTab);
});

export const resetCreditSelectedTabAtom = atom(null, (_, set) => {
  set(creditSelectedTabAtom, null);
});

export const updateCreditAtom = atom(null, (get, set, credit: Credit) => {
  set(creditAtomState, {
    ...get(creditAtomState),
    credit,
  });
});